import GeneralTracker from '../GeneralTracker';


const HOVER_RELEVANCE_TIME = 1000;
const HOVER_END_DELAY = 100;

export default class DirectoryThumbnailTracker extends GeneralTracker {
  CAPTURE_NAME = 'ui:directory:thumbnail:usage';
  EVENT_GROUP = 'directory';
  VERSION = '2';

  constructor() {
    super();

    this.checkpoints = { init: Date.now() };
    this.scheduledHoverEvent = undefined;
  }

  setHandlers() {
    const service = this.getService();

    service.on('directoryThumbnailHover', this.onMouseHover);
    service.on('directoryThumbnailClick', this.onMouseClick);
  }

  getVisiblePerformerInfo = (user) => {
    return {
      name: user.username,
      id: user.userId,

      viewers: user.viewers,
      tags: user.tags,
      new: user.newPerformer,

      mobile: user.mobile,
      source: user.source,
      hdStream: user.hdStream,
      resolution: user.resolution,

      showType: user.showType,

      dailyAward: user.dailyAward,
      monthlyAward: user.monthlyAward,

      snapshotImageLink: user.snapshotImageLink,
      snapshotThumbnailIds: user.snapshotThumbnailIds,
    };
  };

  getSegmentInfo = (thumbnail) => {
    const { container } = thumbnail;

    const segments = document.querySelectorAll('[data-name="Segment"]');

    let thumbnailParent = undefined;
    let segmentIndex = 0;

    for (const segment of segments) {
      segmentIndex += 1;
      if (segment.contains(container)) {
        thumbnailParent = segment;
        break;
      }
    }

    if (thumbnailParent === undefined) {
      return undefined;
    }

    const carousel = thumbnailParent.querySelector('[data-name="Carousel"]');
    const thumbnailsContainer = carousel.children[0];
    const thumbnailContainerParent = container.parentNode;

    const key = thumbnailParent.getAttribute('data-id');
    const size = thumbnailsContainer.children.length;
    const index = Array.from(thumbnailsContainer.children).indexOf(thumbnailContainerParent);
    const scroll = thumbnailsContainer.scrollLeft;

    const segmentWidth = carousel.offsetWidth;
    const thumbnailWidth = container.offsetWidth;

    return {
      id: segmentIndex,
      segmentWidth,
      thumbnailWidth,
      key,
      size,
      index,
      scroll,
    };
  };

  processPayload(payload) {
    const {
      user,
      idx,
      container,
      currentGender,
      genderPreference,
      hover,
      middleMouseButton,
      openInNewTab,
    } = payload;

    const segment = this.getSegmentInfo(payload);

    const parent = container.parentNode.parentNode;

    const parentWidth = parent.offsetWidth;
    const childWidth = container.offsetWidth;

    const numOnRow = Math.floor(parentWidth / childWidth, 10);
    const row = Math.floor(idx / numOnRow, 10);
    const col = idx - (row * numOnRow);

    const session = {};
    const preview = {};

    if (hover !== undefined) {
      let { moment } = session;
      moment = { ...moment, ...{ hover: hover === true ? 'start' : 'end' } };
      session.moment = moment;
    }

    if (hover === true) {
      this.checkpoints.startPreview = Date.now();
    } else {
      this.checkpoints.endPreview = Date.now();
      this.checkpoints.previewDuration = this.checkpoints.endPreview - this.checkpoints.startPreview;

      preview.duration = this.checkpoints.previewDuration;
    }

    const source = {
      type: segment !== undefined ? 'segmented' : 'flat',
      details: {
        ...segment !== undefined && {
          key: segment.key,
          size: segment.size,
          id: segment.id,
        },
      },
    };

    const position = {
      ...idx && {
        type: 'flat',
        flat: {
          index: idx + 1,
          row: row + 1,
          col: col + 1,
        },
      },
      ...segment !== undefined && {
        type: 'segmented',
        thumbnail: {
          number: segment.index + 1,
          width: segment.thumbnailWidth,
          scroll: segment.scroll,
          segmentWidth: segment.segmentWidth,
        },
      },
    };

    const trackPayload = {
      broadcaster: this.getVisiblePerformerInfo(user),
      position,
      preview,
      session,
      source,
      gender: {
        preference: genderPreference,
        current: currentGender,
      },
      ...middleMouseButton && { mouse: { button: 'middle' } },
      openInNewTab,
    };

    return trackPayload;
  }

  later = (payload) => {
    if (this.scheduledHoverEvent) {
      clearTimeout(this.scheduledHoverEvent);
    }

    this.scheduledHoverEvent = setTimeout(() => {
      this.track(payload);
    }, HOVER_RELEVANCE_TIME);
  };

  trackIfRelevant = (trackPayload) => {
    const hoverTime = Date.now() - this.checkpoints.startPreview;
    if (hoverTime > (HOVER_RELEVANCE_TIME + HOVER_END_DELAY)) {
      this.track(trackPayload);
    } else if (this.scheduledHoverEvent) {
      clearTimeout(this.scheduledHoverEvent);
    }

    return true;
  };

  onMouseHover = (payload) => {
    const { hover } = payload;
    const trackPayload = {
      action: 'hoverThumbnail',
      labels: this.processPayload(payload),
    };

    if (hover === true) {
      this.later(trackPayload);
    } else {
      this.trackIfRelevant(trackPayload);
    }
  };

  onMouseClick = (payload) => {
    const trackPayload = {
      action: 'clickThumbnail',
      labels: this.processPayload(payload),
    };

    this.track(trackPayload);
  };
}
